/* eslint-disable */
import { useEffect, useState } from 'react'
import MFIndividualInvestmentsTable from '../../Components/MutualFunds/MFIndividualInvestmentsTable'
import { useRecoilValueLoadable } from 'recoil'
import { FabitsStarFunds, MutualFundsHolding } from '../../store/MFStore'
import MFInvestmentSkeleton from '../../Components/SkeletonLoaders/MFInvestmentSkeleton'
import ApiErrorState from '../../Components/Errors/ApiErrorState'

const MFIndividualInvestments = ({ emptyStateVariant = 'funds' }) => {
  const mfHolding = useRecoilValueLoadable(MutualFundsHolding)
  const fabStarFunds = useRecoilValueLoadable(FabitsStarFunds)

  const [invidualHoldings, setInvidualHoldings] = useState({})

  const groupByISIN = (holdings = []) => {
    const grouped = {}

    holdings.forEach((item) => {
      const isin = item?.isincd
      if (!isin) return

      if (!grouped[isin]) {
        grouped[isin] = { ...item }
      } else {
        grouped[isin] = {
          ...grouped[isin],
          balance: (grouped[isin].balance || 0) + (item.balance || 0),
          netInvestedAmt: (grouped[isin].netInvestedAmt || 0) + (item.netInvestedAmt || 0),
          holding: (grouped[isin].holding || 0) + (item.holding || 0),
        }
      }
    })

    return Object.values(grouped)
  }

  useEffect(() => {
    if (mfHolding?.state === 'hasValue') {
      const filteredHoldings =
        mfHolding?.contents?.mainData?.filter(
          (item) => item?.isOutsideData === 0 && Number(item?.balance) > 0 && item?.isincd,
        ) || []

      const groupedHoldings = groupByISIN(filteredHoldings)

      setInvidualHoldings({ mainData: groupedHoldings })
    } else if (mfHolding?.state === 'hasError') {
      console.error('Error fetching MF holdings:', mfHolding.contents)
    }
  }, [mfHolding])

  switch (mfHolding.state) {
    case 'loading':
      return <MFInvestmentSkeleton />

    case 'hasValue':
      return (
        <>
          {mfHolding.state === 'hasValue' && (
            <MFIndividualInvestmentsTable
              holdings={
                invidualHoldings?.mainData ? invidualHoldings : mfHolding.contents?.mainData
              }
              fabStarFunds={fabStarFunds}
              emptyStateVariant={emptyStateVariant}
            />
          )}
        </>
      )

    case 'hasError':
      return (
        <div className='bg-white flex items-center justify-center'>
          <ApiErrorState />
        </div>
      )

    default:
      return null
  }
}

export default MFIndividualInvestments
